import { LoginExterno } from './LoginExterno';

export default LoginExterno;
